import type { ComponentSchema } from "../../../../../schema-types";
import { SECTION_STYLE_FIELDS } from "../../_builder-constants";

const COLUMN_SCHEMA = [
  {
    key: "icon",
    label: "Icon (truck | shield | lock)",
    type: "string" as const,
  },
  { key: "title", label: "Title", type: "string" as const },
  { key: "subtitle", label: "Subtitle", type: "string" as const },
];

const PROMO_BANNER_SCHEMA = [
  { key: "image", label: "Background Image", type: "image" as const },
  { key: "title", label: "Title", type: "string" as const },
  { key: "subtitle", label: "Subtitle", type: "string" as const },
  { key: "ctaText", label: "Button Text", type: "string" as const },
  { key: "ctaLink", label: "Button Link", type: "string" as const },
];

export const schema: ComponentSchema = {
  type: "banner",
  label: "Banner Section",
  description: "Promo feature strip or side-by-side image banners.",
  supportedPages: ["home", "shop", "categories"],
  variants: [
    {
      id: "v1",
      label: "V1 — Feature Strip (Free Shipping, etc.)",
      fields: [
        { key: "columns", label: "Feature Columns", type: "array", itemSchema: COLUMN_SCHEMA },
      ],
    },
    {
      id: "v2",
      label: "V2 — Two Promo Image Banners",
      fields: [
        { key: "banners", label: "Promo Banners (max 2)", type: "array", itemSchema: PROMO_BANNER_SCHEMA },
      ],
    },
  ],
  commonFields: [...SECTION_STYLE_FIELDS],
};
